import { EventOptions } from './events'

export default class UnhandledError extends Error {
  public exception: string
  public eventName: string
  public options: EventOptions

  constructor(exception: Error, eventName: string, options = {}) {
    super(`Request for "${eventName}" failed: ${exception.message}`)

    this.name = 'UnhandledError'
    this.exception = `${exception}`
    this.eventName = eventName
    this.options = options
  }
}
